import { createActionGroup, props } from '@ngrx/store';
import { SetProductBookingAmanoParkingReservation } from '@products/models/booking.model';
import { SetAmanoParkingReservationDate } from '@products/models/parking.model';

export const AmanoParkingBookingReservationActions = createActionGroup({
  source: 'Amano Parking Booking Reservation',
  events: {
    'Set Amano parking reservation date in booking': props<{
      amanoParkingReservationDate: SetAmanoParkingReservationDate;
    }>(),
    'Set validated Amano parking reservation in booking': props<SetProductBookingAmanoParkingReservation>()
  }
});
